(() => {
  const flagKey = 'pdp-bundles-vs-addons';
  class PdpBundleExperiment {
    constructor(product) {
      this.product = product;
      if (product.dataset.productEmbed === 'true') return;
      const variant = product.getSelectedVariant();
      if (!variant || !product.getOptionalItems(variant).length) return;
      const preview = new URLSearchParams(window.location.search).get('pdp_bundle_preview');
      const previewAllowed = window.Shopify?.designMode || ['development', 'unpublished'].includes(window.Shopify?.theme?.role);
      if (previewAllowed && ['bundles', 'addons'].includes(preview)) {
        product.setBundleLayout(preview);
        product.dataset.bundleExperimentPreview = 'true';
        return;
      }
      if (previewAllowed || window.Shopify?.theme?.role !== 'main' || product.dataset.bundleExperimentEnabled !== 'true') return;
      this.onInteraction = () => { this.interacted = true; };
      product.addEventListener('pointerdown', this.onInteraction, { capture: true });
      product.addEventListener('keydown', this.onInteraction, { capture: true });
      this.onConsent = () => this.initialize();
      window.addEventListener('marmelade:analytics-consent', this.onConsent);
      this.initialize();
    }

    initialize() {
      this.unsubscribe?.();
      this.unsubscribe = undefined;
      if (window.MarmeladeAnalyticsConsent !== true) {
        this.product.setBundleLayout('bundles');
        delete this.product.dataset.bundleExperimentVariant;
        delete this.product.dataset.bundleExperimentAssignment;
        delete this.product.dataset.bundleExperimentDeferred;
        return;
      }
      const sdk = window.posthog;
      if (typeof sdk?.onFeatureFlags !== 'function') return;
      this.unsubscribe = sdk.onFeatureFlags((_flags, variants, context) => {
        if (!this.product.isConnected || window.MarmeladeAnalyticsConsent !== true) return;
        if (context?.errorsLoading) return;
        const variant = variants?.[flagKey];
        if (variant === false || variant === undefined) {
          this.product.setBundleLayout('bundles');
          delete this.product.dataset.bundleExperimentVariant;
          delete this.product.dataset.bundleExperimentAssignment;
          delete this.product.dataset.bundleExperimentDeferred;
          return;
        }
        if (!['control', 'test'].includes(variant) || (this.assigned && this.assigned !== variant)) return;
        this.assignmentDeferred ??= Boolean(this.interacted);
        this.assigned = variant;
        this.product.dataset.bundleExperimentAssignment = variant;
        const layout = variant === 'test' ? 'addons' : 'bundles';
        const deferred = this.assignmentDeferred || (this.interacted && this.product.dataset.bundleLayout !== layout);
        if (deferred) {
          this.product.dataset.bundleExperimentDeferred = 'true';
        } else {
          this.product.setBundleLayout(layout);
          this.product.dataset.bundleExperimentVariant = variant;
          delete this.product.dataset.bundleExperimentDeferred;
        }
        const activeSdk = window.posthog;
        if (Array.isArray(activeSdk) || typeof activeSdk?.capture !== 'function') return;
        const properties = {
          source: 'shopify_theme',
          surface: 'pdp_boxed',
          bundle_layout: this.product.dataset.bundleLayout,
          product_id: this.product.dataset.currentProductId,
          pathname: window.location.pathname
        };
        if (!this.assignmentRecorded) {
          const result = activeSdk.capture('pdp bundle assignment resolved', {
            ...properties,
            experiment_key: flagKey,
            assigned_variant: variant,
            assignment_deferred: this.assignmentDeferred,
            deferral_reason: this.assignmentDeferred ? 'interaction_before_assignment' : null
          });
          if (result != null) this.assignmentRecorded = true;
        }
        if (deferred || this.exposed) return;
        const result = activeSdk.capture('$experiment_exposure', {
          ...properties,
          $feature_flag: flagKey,
          $feature_flag_response: variant,
          [`$feature/${flagKey}`]: variant
        });
        if (result != null) this.exposed = variant;
      });
      sdk.reloadFeatureFlags?.();
    }

    destroy() {
      this.unsubscribe?.();
      if (this.onInteraction) {
        this.product.removeEventListener('pointerdown', this.onInteraction, { capture: true });
        this.product.removeEventListener('keydown', this.onInteraction, { capture: true });
      }
      if (this.onConsent) window.removeEventListener('marmelade:analytics-consent', this.onConsent);
    }
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = PdpBundleExperiment;
  else window.MarmeladePdpBundleExperiment ||= PdpBundleExperiment;
})();
